/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../app/app.component';
const styles_AppComponent:any[] = ([] as any[]);
export const RenderType_AppComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),
      (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(2,212992,(null as any),
      0,i1.RouterOutlet,[i1.ChildrenOutletContexts,i0.ViewContainerRef,i0.ComponentFactoryResolver,
          [8,(null as any)],i0.ChangeDetectorRef],(null as any),(null as any)),(_l()(),
      i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.AppComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i0.ComponentFactory<i2.AppComponent> = i0.ɵccf('app-root',
    i2.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9hcHAvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9hcHAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMuQXBwQ29tcG9uZW50Lmh0bWwiLCJuZzovLy92YXIvYXBwL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbiAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gICIsIjxhcHAtcm9vdD48L2FwcC1yb290PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQSw4Q0FDSTtNQUFBO01BQUEsaUVBQUE7TUFBQTtVQUFBLHFFQUErQjthQUFBO0lBQS9COzs7O29CQ0RKO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts